export const routePageConfig = {
  // #ifdef H5
  register: '/pages/account/register/index',
  // #endif
  // #ifndef H5
  register: '/page_subject/account/register/index',
  // #endif
};

export const distributionSiteUrl = 'page_subject/distributionSite/site/index';

export const historyDistributionInviteUrl = 'pages/distribution/bind/index';

export const newDistributionInviteUrl = 'page_subject/distributionSite/siteRelay/index';

export const historyDistributionSiteUrl = 'pages/distribution/site/index';

export const DISTRIBUTION_PAGE = [
  distributionSiteUrl,
  'page_subject/distributionSite/supplier/index',
  'page_subject/distributionSite/goodsDetail/index',
  newDistributionInviteUrl,
];

export const TABBAR_HOME_PAGE = [
  'pages/stat/index',
  'pages/warehouse/index',
  'pages/my/my/index',
]

export const WHITE_PAGE_LIST = [
  'pages/account/login/index',
  routePageConfig.register.slice(1),
  'page_subject/account/forget-password/index',
  'pages/account/clause/index',
  'page_subject/account/register-success/index',
  ...DISTRIBUTION_PAGE,
  // #ifdef MP-WEIXIN
  ...TABBAR_HOME_PAGE,
  // #endif
];

export const PERMISSION_CODE_MAP = {
  'page_subject/stat/overview/index': 'statSummary',
  'page_subject/stat/overview/saleDetail/index': 'statItemSale',
  'page_subject/stat/profitsOverview/index': 'orderProfitOverview',
  'page_subject/stat/profitDetail/index': 'orderBill',
  'page_subject/stat/productStatistics/index': 'statItemSummary',
  'page_subject/stat/salesStatistics/index': 'statItemSale',
  'page_subject/stat/orderStatistics/index': 'statOrderData',
  'page_subject/stat/shopStatistics/index': 'statOrderShop',
  'page_subject/stat/productSales/index': 'statWarehouseGoodsSale',
  'page_subject/stat/incomeAndExpenditureStatistics/index':
    'statWarehouseStockChange',
  'page_subject/stat/packagingMaterialsStatistics/index': 'statPackaging',
};
